import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export function SleeveDeviceIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-4.5 w-4.5", className)}
    >
      <g clipPath="url(#clip0_6233_40038)">
        <path
          d="M24.86 11.34C24.51 10.8 23.92 10.48 23.28 10.48H15.84C15.2 10.48 14.61 10.8 14.26 11.34L12.61 13.88C12.35 14.29 12.25 14.78 12.34 15.26L14.18 24.86C14.25 25.22 14.42 25.56 14.68 25.82L16.6 27.78C16.95 28.14 17.44 28.35 17.95 28.35H21.18C21.69 28.35 22.17 28.15 22.53 27.78L24.45 25.82C24.71 25.56 24.88 25.22 24.95 24.86L26.79 15.26C26.88 14.78 26.79 14.29 26.52 13.88L24.87 11.34H24.86ZM19.88 22.8H19.23L15.87 16.97L16.38 16.03H22.73L23.24 16.97L19.88 22.8Z"
          fill="currentColor"
        />
        <path
          d="M29.14 6H9.92C8.31 6 7 7.31 7 8.92V30.14C7 31.75 8.31 33.06 9.92 33.06H29.14C30.75 33.06 32.06 31.75 32.06 30.14V8.92C32.06 7.31 30.75 6 29.14 6ZM28.55 15.6L26.71 25.2C26.57 25.91 26.23 26.56 25.73 27.08L23.81 29.04C23.12 29.75 22.16 30.15 21.17 30.15H17.94C16.95 30.15 15.99 29.75 15.3 29.04L13.38 27.08C12.87 26.56 12.53 25.91 12.4 25.2L10.56 15.6C10.38 14.66 10.56 13.7 11.09 12.9L12.74 10.36C13.42 9.31 14.58 8.68 15.83 8.68H23.27C24.52 8.68 25.68 9.31 26.36 10.36L28.01 12.9C28.53 13.7 28.72 14.66 28.54 15.6H28.55Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6233_40038">
          <rect
            width="25.06"
            height="27.06"
            fill="white"
            transform="translate(7 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
